export enum FormOpeningMode {
  Add = 1,
  Edit = 2,
  View = 3
}

export enum UserRole {
  Admin = 1,
  Base_User = 2,
  Reseller = 3
}